import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, FlatList, ActivityIndicator } from 'react-native';
import Colors from '../../../constants/Colorsv2';
import { Text } from '../../../globalComponents/NativeOverrides';
import { MarketProps, OrderBookProps, OrderProps } from '../../../store/types/mk_svc';
import { market_getOddsLabel } from '../helpers/markets';
import { order_calcAmericanOddsFromProbability, order_getCheapestOrders, order_getOrdersFromUniqueVar1, order_getUniqueVar1 } from '../helpers/orders';

type Var1AnalysisCardProps = { 
    order_book:OrderBookProps,
    onVar1Select:any, 
    activeVar1:undefined|number, 
    market: MarketProps, 
    market_type:'FOR_MONEY'|'FREE', 
    side_id_override?:string,
    awayLabel:string, 
    homeLabel:string 
}

const BidAskProgressChart = ({ order_book, side_id_override, onVar1Select, market, activeVar1, awayLabel, homeLabel }:Var1AnalysisCardProps) => {
    const [ loading, setLoading ] = useState(false)
    const [ expanded, setExpanded ] = useState(false);
    const [ width, setWidth ] = useState(300)


    const renderVariableBar = (data: { item: number, index:number }) => {
        const isActive = data.item == activeVar1 ? true :  false
        let trade_side_stat = order_book.book_stats.find(s => s.side === market.trade_side && s.var_1 == data.item)
        if(side_id_override){ trade_side_stat =  order_book.book_stats.find(s => s.side === market.trade_side && s.var_1 == data.item && s.side_id == side_id_override)}
        let o_side_stat = order_book.book_stats.find(s => { 
            if(s.side !== market.trade_side && market.type === 'Spread' && s.var_1 * -1 == data.item){ return s }
            if(s.side !== market.trade_side && market.type !== 'Spread' && s.var_1 == data.item){ return s }
        })
        if(side_id_override){
            o_side_stat = order_book.book_stats.find(s => { 
                if(s.side_id == side_id_override && s.side !== market.trade_side && market.type === 'Spread' && s.var_1 * -1 == data.item){ return s }
                if(s.side_id == side_id_override && s.side !== market.trade_side && market.type !== 'Spread' && s.var_1 == data.item){ return s }
            })
        }
        return (
            <TouchableOpacity style={{flex:1, flexDirection:'row', alignItems:'center', marginBottom:5, borderRadius:8, backgroundColor:isActive?Colors.shades.shade600:Colors.shades.shade100 }} onPress={() => onVar1Select(data.item)}>
                {market.var_1_required ?
                    <Text size={12} textAlign='left' style={{padding:8, flex:1/12}} color={Colors.shades.black}>{market.type === 'Spread'? data.item * -1: data.item}</Text>
                :
                <></>
                }
                <View style={{flex:1, flexDirection:'row', alignItems:'center', justifyContent:'space-between'}} onLayout={(event) => {
                    //if(Math.abs(event.nativeEvent.layout.width - width) < 5){ return }
                    return setWidth(event.nativeEvent.layout.width)
                }}>
                    {o_side_stat ?
                    <View style={{ width: width * (1 - o_side_stat.probability), height:25,  backgroundColor:Colors.chart.cyan, borderRightWidth:1, borderRightColor:Colors.brand.cyan,  borderTopLeftRadius:4, borderBottomLeftRadius:4, flexGrow:0 }}>
                        {100 > -800 ?
                        <View style={{ position: 'absolute', paddingRight:5, top:0, right:0, left:0, bottom:0, justifyContent:'center', alignItems:'flex-end' }}>
                            <Text size={12} textAlign='right' color={Colors.shades.white}>{market_getOddsLabel(order_calcAmericanOddsFromProbability(o_side_stat.probability))}</Text>
                        </View>
                        :<Text size={12} textAlign='right' style={{padding:8}} color={Colors.shades.white}>-</Text> }
                    </View>
                    :
                    <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                        <Text size={12} textAlign='right' style={{padding:8}} color={Colors.shades.black}>No Orders</Text>
                    </View>
                    }
                    {trade_side_stat ?
                    <View style={{  width: width * (1 -trade_side_stat.probability), height:25, backgroundColor:Colors.chart.electric, borderLeftWidth:1, borderLeftColor:Colors.brand.electric, borderTopRightRadius:4, borderBottomRightRadius:4, flexGrow:0 }}>
                        {100 > -800 ?
                        <View style={{ position: 'absolute', paddingLeft:5, top:0, right:0, left:0, bottom:0, justifyContent:'center', alignItems:'flex-start' }}>
                            <Text size={12} textAlign='right' color={Colors.shades.white}>{market_getOddsLabel(order_calcAmericanOddsFromProbability(trade_side_stat.probability))}</Text>
                        </View>
                        :<Text size={12} textAlign='right' style={{padding:8}} color={Colors.shades.white}>-</Text>}
                    </View>
                    :
                    <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                        <Text size={12} textAlign='left' style={{padding:8}} color={Colors.shades.black}>No Orders</Text>
                    </View>
                    }
                </View>
                {market.var_1_required ?
                    <Text size={12} textAlign='right' style={{padding:8, flex:1/12}} color={Colors.shades.black}>{data.item}</Text>
                :
                    <></>
                }
            </TouchableOpacity>
        )
    }
    if(!market || loading || !order_book){ return (
        <View style={{padding:10}}>
            <ActivityIndicator size='small' color={Colors.brand.midnight} />
        </View>
    ) }
    
    let unique_var_1 = [ ...new Set(order_book.book_stats.map(s => {
        if(market.type != 'Spread'){ return s.var_1 }
        if(s.side !== market.trade_side){ return s.var_1 * -1 }
        return s.var_1
    })) ]

    let var_1_options = unique_var_1

    if(side_id_override){
        unique_var_1 = [ ...new Set(order_book.book_stats.filter(s => s.side_id == side_id_override).map(s => {
        if(market.type !== 'Spread'){ return s.var_1 }
        if(s.side !== market.trade_side){ return s.var_1 * -1 }
        return s.var_1
    })) ]
    }

    if(!expanded && activeVar1){
        var_1_options = [activeVar1]
    }

    return (
        <View style={{flex:1, margin:20, marginTop:5 }}>
            {unique_var_1.length > 0 ?
            <>
            <View style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginBottom:8}}>
                <Text size={14} weight='semibold' color={Colors.shades.black} textAlign='left'>{awayLabel?.toUpperCase()??'TBD'}</Text>
                <Text size={14} weight='semibold' color={Colors.shades.black} textAlign='center'>{market.stat_label ?? market.type?.toUpperCase()??'TBD'}</Text>
                <Text size={14} weight='semibold' color={Colors.shades.black} textAlign='right'>{homeLabel?.toUpperCase()??'TBD'}</Text>
            </View>
            <FlatList data={var_1_options.sort((a,b) => a - b)} renderItem={renderVariableBar} keyExtractor={(item) => item.toString()} extraData={width} />
            <TouchableOpacity style={{ padding:10 }} onPress={() => setExpanded(!expanded)}>
                {!expanded ?
                <Text size={12} color={Colors.brand.electric} weight='semibold' textAlign='center'>{unique_var_1.length} Other {market.type}s Available</Text>
                :
                <Text size={12} color={Colors.utility.error} weight='semibold' textAlign='center'>Hide Alternatives</Text>
                }
            </TouchableOpacity>
            </>
            :
            <Text size={12} textAlign='center' style={{padding:8}} color={Colors.shades.black}>No Active Orders</Text> 
            }
        </View>
    )
}


export default BidAskProgressChart